import { render, staticRenderFns } from "./removalDialog.vue?vue&type=template&id=7ea1ef5c&scoped=true"
import script from "./removalDialog.vue?vue&type=script&lang=js"
export * from "./removalDialog.vue?vue&type=script&lang=js"
import style0 from "./removalDialog.vue?vue&type=style&index=0&id=7ea1ef5c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ea1ef5c",
  null
  
)

export default component.exports